export default {
  analytics: "Аналитика",
  "legal-entity": "Юрлица",
  "trading-point": "Торговые точки",
  employee: "Кассиры",
  document: "Документы",
  tariff: "Тарифы",
  operation: "История операций",
  "act-and-receipt": "Акты и счета",
  manager: "Менеджеры",
  cashback: "Начисление баллов",
  balance: "Баланс",
  points: "Очки кассирам",
  client: "Список клиентов",
  spread: "Распространение карт RC",
  "wallet-pass": "Дизайн карты Wallet",
  review: "Отзывы",
  "noncash-tips": "Безналичные чаевые",
  "check-counterparties": "Проверка контрагентов",
  "push-notifications": "Push-уведомления Wallet",
  "client-portrait": "Портрет клиента",
  "active-wait": "Начисление баллов (Активное ожидание)",
  "e-menu": "Онлайн каталог",
  "telegram-notification": "Уведомления в Telegram",
  faq: "FAQ",
  terminal: "Processing",
  promotion: "Акции",
  cashback_group: "Начисление баллов (Группы клиентов)",
  payment_info: "Способы оплаты",
  orders: "Заказы / Меню RC PAY",
  "trading-point-promotion": "Продвижение",
  "gift-card": "Подарочные карты",
  "kassa-orders": "Заказы / Каталог RC KASSA",
  "partner-profile": "Профиль партнера",
};
